export function AlertBadge() {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-100 px-3 py-1 text-xs font-semibold text-brand-700 ring-1 ring-brand-200/60">
      <svg
        viewBox="0 0 16 16"
        className="h-3.5 w-3.5"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M8 1.5a.75.75 0 0 1 .75.75v.566c2.32.336 4 2.296 4 4.684v2.057l1.05 1.575a.75.75 0 0 1-.624 1.168H2.824a.75.75 0 0 1-.624-1.168l1.05-1.575V7.5c0-2.388 1.68-4.348 4-4.684V2.25A.75.75 0 0 1 8 1.5Zm-1.5 11.5h3a1.5 1.5 0 0 1-3 0Z" />
      </svg>
      우리엔 알림
    </span>
  );
}
